import { render } from "./IconElectraGears.vue?vue&type=template&id=4e438319"
import script from "./IconElectraGears.vue?vue&type=script&lang=js"
export * from "./IconElectraGears.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__